import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { StartupService } from '../../services/startup.service';
import { BtnDownloadCellRenderer } from "../button-download-cell-renderer.component"
import { BtnDeleteCellRenderer } from "../button-delete-cell-renderer.component"
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { FileToUpload } from "../filetoupload"
import { saveAs } from 'file-saver'
import { ServiceLocator } from "../../services/service.locator"
import { ConfirmDialog } from '../.././confirmation/confirm.dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { ColDef, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AuthService } from '../../services/auth.service';
import { DriverScheduleService } from '../../services/driverschedule.service';



export interface IDrivingSchedule {
  name: string;
  uploaded: Date;
  type: string;
}

@Component({
  selector: 'driving-schedule',
  templateUrl: 'driving-schedule.component.html',
  styleUrls: ['../administration.component.css'],

})

export class DrivingScheduleComponent implements OnInit {
  displayedColumns: string[] = ['name', 'uploaded', 'type'];
  scheduleList: any;
  headerHeight = 32;
  fetchingData = true;
  authenticatedSubsciption$: Subscription;

  confirmModalRef: MatDialogRef<ConfirmDialog>;


  scheduleColumnDefs: ColDef[] = [
    {
      headerName: 'Namn', field: 'name', lockPosition: true, width: 250, sortingOrder: ["asc", "desc"]
    },
    {
      headerName: 'Uppladdningsdatum', field: 'uploaded', lockPosition: true, width: 350,
      cellRenderer: (result) => {
        return result.data.uploaded ? this.getTime(result.data.uploaded) : "";
      }
    },
    {
      headerName: '',
      field: 'upload',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      lockPosition: true,
      cellRendererSelector: params => {
        return {
          component: BtnDownloadCellRenderer,
          params: { clicked: this.buttonDownloadCallback }
        };
      }
    },
    {
      headerName: '',
      field: 'delete',
      width: 130,
      minWidth: 130,
      maxWidth: 130,
      lockPosition: true,
      cellRendererSelector: params => {
        return {
          component: BtnDeleteCellRenderer,
          params: { clicked: this.buttonDeleteCallback }
        };
      }
    }
  ];

  public gridOptions: GridOptions = {
    headerHeight: 32,
    animateRows: true,
    singleClickEdit: false,
    enableCellChangeFlash: false,
    columnDefs: this.scheduleColumnDefs,
    // Event handlers
    onGridReady: (event: GridReadyEvent) => this.onGridReady(event),
  }

  constructor(
    private readonly startupService: StartupService,
    private readonly toaster: ToastrService,
    private readonly authService: AuthService,
    private readonly driverScheduleService: DriverScheduleService) {
  }

  ngOnInit() {
    if (!this.startupService.isLoggedIn) {
      this.authenticatedSubsciption$ = this.authService.authReady$.subscribe((param: string) => {
        this.loadData();
      });
    }
    else
      this.loadData();
  }

  loadData() {
    this.scheduleList = [];
    if (!this.startupService.isLoggedIn) return false;

    this.fetchingData = true;
    this.driverScheduleService.getAllDriverSchedules()
      .then(result => {
        let list = [];
        result.forEach(r => {
          list.push({ name: r.fileName, uploaded: r.changeDate, type: r.fileType });
        });
        this.scheduleList = list;
        this.fetchingData = false;
        return;
      }, error => {
        this.fetchingData = false;
        console.log(error);
        return;
      });
  }


  getTime(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  }
  onGridReady(params) {
    params.api.sizeColumnsToFit();
  }

  openFile() {
    document.querySelector('input').click();
  }

  handle(e) {

    const theFile = e.target.files[0];
    e.target.value = null;
    let file = new FileToUpload();

    // Set File Information
    file.fileName = theFile.name;

    if (theFile.type !== "application/pdf" && theFile.type !== "image/png") {
      this.toaster.error("Endast PDF eller PNG-filer tillåtna!");
      return;
    }

    // Use FileReader() object to get file to upload
    // NOTE: FileReader only works with newer browsers

    let reader = new FileReader();
    reader.onload = () => {
      // Store base64 encoded representation of file
      file.fileAsBase64 = reader.result.toString();

      // POST to server
      this.driverScheduleService.uploadDriverSchedule(file)
        .then(resp => {
          let res = Boolean(resp);
          if (res === false)
            this.toaster.error("Det gick inte att ladda upp körschemat!");
          else {
            this.loadData();
            this.toaster.info("Körschema uppladdat!");

          }
          console.log(resp);
        },
          (errorData) => {
            console.log(errorData);
            let len = 50;
            if (errorData.error.exceptionMessage.indexOf(".") > -1 && errorData.error.exceptionMessage.indexOf(".") <= 50)
              len = errorData.error.exceptionMessage.indexOf(".");
            this.toaster.error(errorData.error.exceptionMessage.substring(0, len), errorData.error.message);
          });
    }

    // Read the file
    reader.readAsDataURL(theFile);

  }

  buttonDownloadCallback(buttonScope) {
    let scheduleName = buttonScope.params.data.name;
    ServiceLocator.driverScheduleService.getDriverSchedule(scheduleName)
      .then(
        (result) => {
          const data = result.replaceAll('"', "");
          const byteCharacters = atob(data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray]);
          saveAs(blob, scheduleName);
        },
        (errorData) => {
          console.log(errorData);
          let len = 50;
          if (errorData.error.exceptionMessage.indexOf(".") > -1 && errorData.error.exceptionMessage.indexOf(".") <= 50)
            len = errorData.error.exceptionMessage.indexOf(".");
          ServiceLocator.toastr.error(errorData.error.exceptionMessage.substring(0, len), errorData.error.message);
        });
  }

  buttonDeleteCallback(buttonScope) {

    let filename = buttonScope.params.data.name;

    this.confirmModalRef = ServiceLocator.dialog.open(ConfirmDialog, {
      disableClose: false,
      width: "400px",
      autoFocus: false,
      closeOnNavigation: false, data:
      {
        id: 1,
        title: "Bekräfta",
        text: "Vill du verkligen radera " + filename + "?<br>"
      }
    });

    this.confirmModalRef.afterClosed().subscribe(result => {
      if (result) {
        ServiceLocator.driverScheduleService.deleteDriverSchedule(filename)
          .then(
            (result) => {
              const res = Boolean(result);
              if (res === false)
                buttonScope.params.toaster.error("Det gick inte radera filen " + filename);
              else {
                buttonScope.params.api.applyTransaction({ remove: [buttonScope.params.data] });
                ServiceLocator.toastr.info("Filen " + filename + " raderat!");
              }
            },
            (errorData) => {
              console.log(errorData);
              let len = 50;
              if (errorData.error.exceptionMessage.indexOf(".") > -1 && errorData.error.exceptionMessage.indexOf(".") <= 50)
                len = errorData.error.exceptionMessage.indexOf(".");
              ServiceLocator.toastr.error(errorData.error.exceptionMessage.substring(0, len), errorData.error.message);
            });
      }
    });

  }
}
